var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReference28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 11a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-4a4 4 0 1 0 2.72 6.933 12.896 12.896 0 0 1-5.496 8.07.5.5 0 1 0 .552.833A13.9 13.9 0 0 0 12 11.51v-.518A4 4 0 0 0 8 7Zm10 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-4a4 4 0 1 0 2.72 6.933 12.895 12.895 0 0 1-5.496 8.07.5.5 0 0 0 .552.833A13.899 13.899 0 0 0 25 11.51v-.518A4 4 0 0 0 21 7Z",
  clipRule: "evenodd"
})));
export { SvgReference28 as ReactComponent };
export default __webpack_public_path__ + "f89f305c42d783085494bab529aae5d3.svg";